import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateStepsStahltreppe,
        selectStufenBreite
        } from '../../../../store/actions/stahltreppen';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';


const Step_4 = (props) => {

    const [stufenBreite, updateStufenBreite] = useState('');

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
       let stufen_breite = props.data.stufenBreite;

        updateStufenBreite(stufen_breite);

        //update steps
        props.updateSteps(2);

        if(stufenBreite || props.data.allVisitedSteps) {
            props.updateSteps(3);
            props.setUpdateButtonActiveStepToFalse();
        } else {
            props.setUpdateButtonActiveStepToTrue()
        }

   }

   const selectStufenBreite = ev => {
       let stufenbreite = ev.target.value;
       props.selectStufenBreite(stufenbreite);
       updateItems();
   }

   let stufenbreite_options = [
       {titel: '600 mm'},
       {titel: '700 mm'},
       {titel: '800 mm'},
       {titel: '900 mm'},
       {titel: '1000 mm'}
   ]


    return (
        <div className="step_wrapper">
            <h2 className='step_header'>Welche Breite sollen die Stufen haben?</h2>
              <div className="step_icon_wrapper">
                <div className="inner_textfield_wrapper">
                  {/* <label className='label_description'>Form des Handlaufs</label> */}
                    <TextField
                        className="textfield"
                        label="Bitte wählen"
                        type="text"
                        select
                        rowsMax={1}
                        value={stufenBreite}
                        onChange={selectStufenBreite}
                    >
                        {stufenbreite_options.map((option, index) => (
                            <MenuItem key={index} name='elements_equal' value={option.titel}>
                                {option.titel}
                            </MenuItem>
                        ))}
                    </TextField>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        data: state.stahltreppenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateSteps: ev => dispatch(updateStepsStahltreppe(ev)),
      selectStufenBreite: ev => dispatch(selectStufenBreite(ev))

   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_4);
